module.exports = __webpack_public_path__ + "static/media/choose-atk.32186e5e.png";